// 导入 GSAP 库和 ScrollTrigger 插件
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// 注册 ScrollTrigger 插件，以便 GSAP 可以使用它
$(function () {
    // 注册 ScrollTrigger 插件
    gsap.registerPlugin(ScrollTrigger);
    // 定义断点（用于响应式设计）
    const BREAKPOINT = 992;
    const mobile = window.innerWidth <= BREAKPOINT ? true : false;

    // 监听窗口大小变化，更新断点变量
    $(window).resize(function () {
        mobile = window.innerWidth <= BREAKPOINT ? true : false;
    });
    // 五大模式
    // 创建一个 GSAP 时间轴动画，并绑定 ScrollTrigger
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".ruyi-mode", // 触发器元素
            start: mobile ? "top 69" : "top top",                // 触发器起始位置：元素顶部距离视口顶部 -50px 时触
            end: "200%",                    // 触发器结束位置：滚动到元素高度的 100% 时结束
            pin: true,                      // 固定触发器元素
            //markers: true,                   // 显示调试标记（用于开发阶段）
            scrub: true               // 动画与滚动速度同步
        }
    });

    const dutime=0;
    // 在时间轴中添加动画
    tl.to(".ruyi-mode .section-md .item-1 .left", {
        duration: dutime,   // 动画持续时间：2 秒
        y: 0,     // 动画效果：垂直向上移动 100%
        delay: 0.5,     // 动画延迟：0.5 秒
        //opacity: 1,   // （注释掉的代码）可以设置透明度变化
        //stagger: 0.1, // （注释掉的代码）可以设置多个元素的交错动画
        //ease: "power3.inOut" // （注释掉的代码）可以设置动画的缓动效果
    }).to(".ruyi-mode .section-md .item-1 .right", {
        opacity: 1,
        duration: dutime,
    }, "<");
    // 第二个动画
    tl.to(".ruyi-mode .filter-bg .cover-2", {
        duration: dutime,   // 动画持续时间：2 秒
        //y: 0,     // 动画效果：垂直向上移动 100%
        delay: 1,     // 动画延迟：0.5 秒
        opacity: 1,   // （注释掉的代码）可以设置透明度变化
        //stagger: 0.1, // （注释掉的代码）可以设置多个元素的交错动画
        //ease: "power3.inOut" // （注释掉的代码）可以设置动画的缓动效果
    }).to(".ruyi-mode .section-md .item-1 .right", {
        duration:dutime,
        opacity:0,
        //delay:2
    }, "<").to(".ruyi-mode .section-md .item-2 .left", {
        duration: dutime,   // 动画持续时间：2 秒
        y: 0,     // 动画效果：垂直向上移动 100%
        //delay: 0.5,     // 动画延迟：0.5 秒
        //opacity: 1,   // （注释掉的代码）可以设置透明度变化
        //stagger: 0.1, // （注释掉的代码）可以设置多个元素的交错动画
        //ease: "power3.inOut" // （注释掉的代码）可以设置动画的缓动效果
    },"<").to(".ruyi-mode .section-md .item-2 .right", {
        opacity: 1,
        duration: dutime,
    }, "<");
    // 第三个动画
    tl.to(".ruyi-mode .filter-bg .cover-3", {
        duration: dutime,   // 动画持续时间：2 秒
        //y: 0,     // 动画效果：垂直向上移动 100%
        delay: 1,     // 动画延迟：0.5 秒
        opacity: 1,   // （注释掉的代码）可以设置透明度变化
        //stagger: 0.1, // （注释掉的代码）可以设置多个元素的交错动画
        //ease: "power3.inOut" // （注释掉的代码）可以设置动画的缓动效果
    }).to(".ruyi-mode .section-md .item-2 .right", {
        duration:dutime,
        opacity:0,
        //delay:2
    }, "<").to(".ruyi-mode .section-md .item-3 .left", {
        duration: dutime,   // 动画持续时间：2 秒
        y: 0,     // 动画效果：垂直向上移动 100%
        //delay: 0.5,     // 动画延迟：0.5 秒
        //opacity: 1,   // （注释掉的代码）可以设置透明度变化
        //stagger: 0.1, // （注释掉的代码）可以设置多个元素的交错动画
        //ease: "power3.inOut" // （注释掉的代码）可以设置动画的缓动效果
    },"<").to(".ruyi-mode .section-md .item-3 .right", {
        opacity: 1,
        duration: dutime,
    }, "<");
    // 第四个动画
    tl.to(".ruyi-mode .filter-bg .cover-4", {
        duration: dutime,   // 动画持续时间：2 秒
        //y: 0,     // 动画效果：垂直向上移动 100%
        delay: 1,     // 动画延迟：0.5 秒
        opacity: 1,   // （注释掉的代码）可以设置透明度变化
        //stagger: 0.1, // （注释掉的代码）可以设置多个元素的交错动画
        //ease: "power3.inOut" // （注释掉的代码）可以设置动画的缓动效果
    }).to(".ruyi-mode .section-md .item-3 .right", {
        duration:dutime,
        opacity:0,
        //delay:2
    }, "<").to(".ruyi-mode .section-md .item-4 .left", {
        duration: dutime,   // 动画持续时间：2 秒
        y: 0,     // 动画效果：垂直向上移动 100%
        //delay: 0.5,     // 动画延迟：0.5 秒
        //opacity: 1,   // （注释掉的代码）可以设置透明度变化
        //stagger: 0.1, // （注释掉的代码）可以设置多个元素的交错动画
        //ease: "power3.inOut" // （注释掉的代码）可以设置动画的缓动效果
    },"<").to(".ruyi-mode .section-md .item-4 .right", {
        opacity: 1,
        duration: dutime,
    }, "<");
    // 第五个动画
    tl.to(".ruyi-mode .filter-bg .cover-5", {
        duration: dutime,   // 动画持续时间：2 秒
        //y: 0,     // 动画效果：垂直向上移动 100%
        delay: 1,     // 动画延迟：0.5 秒
        opacity: 1,   // （注释掉的代码）可以设置透明度变化
        //stagger: 0.1, // （注释掉的代码）可以设置多个元素的交错动画
        //ease: "power3.inOut" // （注释掉的代码）可以设置动画的缓动效果
    }).to(".ruyi-mode .section-md .item-4 .right", {
        duration:dutime,
        opacity:0,
        //delay:2
    }, "<").to(".ruyi-mode .section-md .item-5 .left", {
        duration: dutime,   // 动画持续时间：2 秒
        y: 0,     // 动画效果：垂直向上移动 100%
        //delay: 0.5,     // 动画延迟：0.5 秒
        //opacity: 1,   // （注释掉的代码）可以设置透明度变化
        //stagger: 0.1, // （注释掉的代码）可以设置多个元素的交错动画
        //ease: "power3.inOut" // （注释掉的代码）可以设置动画的缓动效果
    },"<").to(".ruyi-mode .section-md .item-5 .right", {
        opacity: 1,
        duration: dutime,
    }, "<");




    // 注册一个GSAP自定义效果
    gsap.registerEffect({
        name: "fadeIn",
        effect: (targets, config) => {
            return gsap.to(targets, { duration: config.duration, delay:config.delay, opacity: 1, y: 0 });
        },
        defaults: { duration: 2 }, //defaults get applied to any "config" object passed to the effect
        extendTimeline: true, //now you can call the effect directly on any GSAP timeline to have the result immediately inserted in the position you define (default is sequenced at the end)
    });

    // 玉如意-年轻肌底
    let tla = gsap.timeline({
        scrollTrigger: {
            trigger: ".ruyi-young", // 触发器元素
            start: "top 200",               // 触发器起始位置：元素顶部距离视口顶部 -50px 时触
            end: "100%",                    // 触发器结束位置：滚动到元素高度的 100% 时结束
            pin: false,                      // 固定触发器元素
            //markers: true,                   // 显示调试标记（用于开发阶段）
            //scrub: true               // 动画与滚动速度同步
        }
    });
    tla.fadeIn(".ruyi-young .container", { duration: 1 });

    // 玉如意-年轻肌底
    let tlb = gsap.timeline({
        scrollTrigger: {
            trigger: ".ruyi-sgs", // 触发器元素
            start: "top 200",               // 触发器起始位置：元素顶部距离视口顶部 -50px 时触
            end: "100%",                    // 触发器结束位置：滚动到元素高度的 100% 时结束
            pin: false,                      // 固定触发器元素
            //markers: true,                   // 显示调试标记（用于开发阶段）
            //scrub: true               // 动画与滚动速度同步
        }
    });
    tlb.fadeIn(".ruyi-sgs h2", { duration: 1,delay:1  });

    // 玉如意-智能温控
    let tlc = gsap.timeline({
        scrollTrigger: {
            trigger: ".ruyi-smart", // 触发器元素
            start: "top 200",               // 触发器起始位置：元素顶部距离视口顶部 -50px 时触
            end: "100%",                    // 触发器结束位置：滚动到元素高度的 100% 时结束
            pin: false,                      // 固定触发器元素
            //markers: true,                   // 显示调试标记（用于开发阶段）
            //scrub: true               // 动画与滚动速度同步
        }
    });
    tlc.fadeIn(".ruyi-smart .section-hd", { duration: 1,delay:1  });
});